// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1vw4S","actions":"GroupTable_actions__3ivuh","deleteModalFooter":"GroupTable_deleteModalFooter__1uoko"};